import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';
import { Location1Service } from '../location1.service';

@Component({
  selector: 'app-org-profile',
  templateUrl: './org-profile.component.html',
  styleUrls: ['./org-profile.component.scss'],
})
export class OrgProfileComponent  {

  list: any = [
    { name: 'Personal', style: 'none', id: 0 },
    { name: 'Present Addr', style: 'none', id: 1 },
    { name: 'Billing Addr', style: 'none', id: 2 },
    { name: 'Pay Account', style: 'none', id: 3 },  
    { name: 'Regions', style: 'none', id: 4 },
    { name: 'Categories',style: 'none', id:5},
    { name: 'Logo', style: 'none', id: 6 },
   
  ];
  personal:boolean;
  region;
  logo:boolean;
  payAccounts:boolean;
  personaladd: boolean;
  billingadd: boolean;
  name;
  mobile;
  email;
  accName;
  accNumber;
  ifsc;
  bankName;
  branch;
  items;
  pic;
  newSearch:any;
  newSearch1:any;
  newSearch2:any;
  postalCodeLength;
  id;
  postalCd;
  postalArray:any=[];
  catArray:any=[];
  orgObj;
  PresentAddress:any;
  BillingAddress:any;
  accountDetails:any;
  loader:boolean=true;
  url;
  activeInd:boolean = false;
  category;
  

  constructor(public service: ApiService,
              public handler: HandlerService,
              public present: LocationService,
              public billing: Location1Service,
              public router:Router) { }

  ionViewWillEnter() {
    this.list[0].style='highlight';
    this.personal=true;
    this.url = window.location.href;
    var orgId = this.url.split('/').pop();
    if(this.url.includes('org-profile')){
      this.id = localStorage.getItem('organizationId');
    }else{
      this.id = orgId;
    }
    this.getCategory();
  }

  getProfile(){
    this.service.getOrgById(this.id).subscribe((res: any) => {
      this.orgObj=res;
      if(this.orgObj.serviceRegions){
        this.postalArray=this.orgObj.serviceRegions
      }
       if(this.orgObj.name)
        this.name=this.orgObj.name;
        if(this.orgObj.contactNbrMob)
        this.mobile=this.orgObj.contactNbrMob;
        if(this.orgObj.emailId)
        this.email=this.orgObj.emailId;
        if(this.orgObj.logo)
        this.pic = this.orgObj.logo; 
        
        
    if (this.orgObj.addresses) {
      if(this.orgObj.addresses[0]){
        let data = this.orgObj.addresses[0];
        this.present.stateId = data.stateId;
        this.present.cityId = data.cityId;
        this.present.regionId = data.regionId;
        this.present.houseNbr = data.houseNbr;
        this.present.zipcode = data.zipcode;
        this.present.lat = data.lat;
        this.present.lon = data.lon;
      }
      
      if(this.orgObj.addresses[1]){
        let data1=this.orgObj.addresses[1]
        this.billing.stateId = data1.stateId;
        this.billing.cityId = data1.cityId;
        this.billing.regionId = data1.regionId;
        this.billing.houseNbr = data1.houseNbr;
        this.billing.zipcode = data1.zipcode;
        this.billing.lat = data1.lat;
        this.billing.lon = data1.lon;
    }
   }

   if(this.orgObj.paymentAccounts){
     let dat= this.orgObj.paymentAccounts[0];
     if(dat){
      this.accName = dat.accountName;
      this.accNumber = dat.accountNbr;
      this.ifsc = dat.finCompCd;
      this.bankName = dat.finCompName;
      this.branch = dat.branch;
     }
   }
   if(this.orgObj.categories){
     this.orgObj.categories.map(res=>{
        this.items.map(res1=>{
          if(res==res1.id){
            Object.assign(res1,{switch:true})
          }
        })
     })
   }
   this.activeInd = this.orgObj.activeInd;
   setTimeout(() => {
    this.loader = false;
   }, 1000);
  },err => {
    this.handler.err(err);
    this.loader = false;
  })
  }

  checkBox(data){
    this.loader=true;
    data.style="highlight";
    var x = this.list.filter(res => res.id != data.id);
    x.map(res=>{
      Object.assign(res,{style:"none"})
    })  
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  }

    handleFile(files) {
        var img = new Image();
        img.src = URL.createObjectURL(files[0]);
        img.onload = (data) => {
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          this.pic = canvas.toDataURL('image/jpeg', 1.5);
      }
    }


    getPostal(){        
        this.postalArray.push({orgId:this.id,region:this.present.regionIdName})
        this.handler.res("Region Added");      
        this.present.regionIdName="";
  }

    clearPostalCd(i) {
      if(this.postalArray.length >1){
        this.postalArray.splice(i, 1);
      }else{
        this.handler.error("Can't Delete ,Atleast One Region Mandatory")
      }
    }

    onInput() {
      this.present.autoComplete();
    }
  
    onInput1() {
      this.billing.autoComplete();
    }

    onInput2() {
      this.present.autoComplete1();
    }


    serviceSelect(i,data){
     data.switch = !data.switch
     this.category = this.items.filter(res => res.switch);
    }

    save(){
      this.loader = true;
      if(this.list[0].style=='highlight'){
        this.orgObj.name = this.name;
        this.orgObj.contactNbrMob = this.mobile;
        this.orgObj.emailId = this.email;
      }
      
      if(this.list[1].style=='highlight'){
        let x;
      this.PresentAddress = {
        cityId: this.present.cityId,
        regionId: this.present.regionId,
        stateId: this.present.stateId,
        houseNbr: this.present.houseNbr,
        street: this.present.street,
        zipcode: this.present.zipcode,
        lat: this.present.lat,
        lon: this.present.lon,
        type: 1,
        userId: localStorage.getItem('currentUserId'),
        orgId: localStorage.getItem('organizationId'),
      }
      if(!this.orgObj.addresses)
       Object.assign(this.orgObj,{addresses:[]})
      if (this.orgObj.addresses.length == 0){
        this.orgObj.addresses.push(this.PresentAddress)
      }
      else{
        x=this.orgObj.addresses.findIndex(res=>res.type==1);
        if(x<0){
          this.orgObj.addresses.push(this.PresentAddress)
        }else{
          this.orgObj.addresses[x]=this.PresentAddress;
        }
      }
    }
     
      if(this.list[2].style=='highlight'){
        let y;
        this.BillingAddress = {
        cityId: this.billing.cityId,
        regionId: this.billing.regionId,
        stateId: this.billing.stateId,
        houseNbr: this.billing.houseNbr,
        street: this.billing.street,
        zipcode: this.billing.zipcode,
        lat: this.billing.lat,
        lon: this.billing.lon,
        type: 2,
        userId: localStorage.getItem('currentUserId'),
        orgId: localStorage.getItem('organizationId'),
      }
      if(!this.orgObj.addresses)
       Object.assign(this.orgObj,{addresses:[]})
      if (this.orgObj.addresses.length == 0)
        this.orgObj.addresses.push(this.BillingAddress)
        else{
          y=this.orgObj.addresses.findIndex(res=>res.type==2);
          if(y<0){
            this.orgObj.addresses.push(this.BillingAddress)
          }else{
            this.orgObj.addresses[y]=this.BillingAddress
          }
        }
      }
      
      if(this.list[3].style=='highlight'){
        var z ={
          "accountName": this.accName,
          "finCompName": this.bankName,
          "branch": this.branch,
          "accountNbr": this.accNumber,
          "activeInd": true,
          "finCompCd": this.ifsc,
          "orgId": this.id
         }
         if(!this.orgObj.paymentAccounts){
           Object.assign(this.orgObj,{paymentAccounts:[]})
           this.orgObj.paymentAccounts.push(z)
         }else{
           this.orgObj.paymentAccounts[0]=z
         }

      }
      
      if(this.list[4].style=='highlight'){
        this.orgObj.serviceRegions=this.postalArray;
      }
      
      if(this.list[6].style=='highlight'){
        this.orgObj.logo = this.pic;
      }

      if(this.list[5].style=='highlight'){
        this.category.map(res=>{
          this.catArray.push(res.id)
        })
        this.orgObj.categories=this.catArray;
      }
      this.orgObj.activeInd = this.activeInd;
      this.service.updateOrg(this.id,this.orgObj).subscribe(res=>{
        this.handler.res("Updated Successfully");
        if(this.url.includes('org-profile')){
          this.router.navigate(['admin/'])
        }else{
          this.router.navigate(['manage-org/'])
        } 
        this.loader = false;
      },err => {
        this.handler.err(err);
        this.loader = false;
      })
    }

    ionViewWillLeave(){
      this.list[1].style = 'none';
      this.list[2].style = 'none';
      this.list[3].style = 'none';
      this.list[4].style = 'none';
      this.list[5].style = 'none';
      this.list[6].style = 'none';
    }

    getCategory(){
      this.service.getOrgCategory().subscribe((res: any) => {
        this.items=res;
        this.items.map(res=>{
          Object.assign(res,{switch:false})
        })
        this.getProfile(); 
      },
      err => {
        this.handler.err(err);
        this.loader = false;
      })
    }
}
